
import { defineComponent, reactive } from 'vue';
import { useTelaBase } from '@/core/composables/TelaBase';

export default defineComponent({
  name: 'ConhecimentoTransporteFinanceiro',
  setup() {
    const { telaBase } = useTelaBase();
    const state = reactive({});

    return {
      telaBase,
      state,
    };
  },
});
